import React, { useEffect, useState } from 'react';
import { Grid, Typography, Row, Col, Spin, Result, ConfigProvider, Card } from 'antd';
import whatsappico from '../img/whatsapp-icon.png';
import llamadaico from '../img/llamadaicon.png';
import NavBar from './NavBar';
import { recuperarCargoOpenPay } from '../api/openPay';
import { getDataPedidoOrigen, getDataLigasIdPedido, getDataPedido, getDataLigas, getDataDetallePedido } from '../api/pagoPasarela';
import { getProductosDescripciones } from '../api/productoService';
import { desencryptURL, createProductosObj, formatDate } from '../utils/helper';
import { getDataTipoSucursal } from '../api/sucursalesService';
import { enviarCorreoPago } from '../api/enviarCorreoPago';
import { updateDataLiga } from '../api/pagoPasarela';
import { Footer } from '../components/Footer';
import { InformacionPagoCompletado } from './InformacionPagoCompletado';
import Error from '../components/Error';
import { format } from 'url';
import '../styles/Pagado.css';
import { ORIGEN_ID, ORIGEN_CONFIG } from '../utils/origenes.config';
import { EstatusPagoEnum } from '../utils/estatusPagoEnum';



const { Title } = Typography;


/**
 * Componente para mostrar vista de liga pagada
 * @param {idCargo} Pagado 
 * @returns vista con diseño de pagado
 */
const Pagado = ({ idCargo}) => {
  const cardPrincipalStyle = {
    width: '100%',
    boxShadow: '1px 10px 10px 1px rgba(90, 116, 148, 0.3)',
    borderRadius: '0px',
    marginBottom: '30px',
    zIndex: '',
  };

  const cardBodyStyle = {
    width: '100%',
    borderRadius: '0px',
    height: '100%',
  };

  const rowFooterStyle = {
    bottom: '0px',
    position: 'absolute',
    width: '100%',
    marginTop: '0px'
  };

  const footerStyle = {
    textAlign: 'center',
    color: 'gray',
    position: 'absolute',
    width: '100%',
    marginTop: '30px',
    paddingLeft: '0px',
    paddingRight: '0px',
  };

  const containerStyle = {
    position: 'absolute',
    maxwidth: '1200px',
    maxHeight: '1456px',
    alingcontent: 'center'
  };

  const stylesNavBar = {
    navBarHeigth: '70px',
    iconsNavbarWidth: '165px',
    iconsNavbarHeigth: '200px',
    stepsWidth: '25px',
    stepsHeigth: '25px',
    stepsSize: '',
    stepsCurrent: 1
  };

  const divresponsive = {
    position: 'relative',
    display: 'grid',
    placeItems: 'center',
    aling: 'center',
    top: '0',
    bottom: '0',
    minHeight: '150px',
    height: '100vh'
  };
   const styleprecio = {
            textAlign: 'right',
            padding: '0px'
  };
  const divStyle = {
    position: 'flex',
    background: 'linear-gradient(270deg, #1a3992 0%, #e6002b 100%)',
    height: '2px',
    transform: 'matrix(-1, 0, 0, 1, 0, 0)',
    bottom: '0px',
    marginBottom: '100px'
  }
  const stylesResumen = {
    boxShadow: '400px',
    borderRadius: '0px'
  };
  const [isSuccess, setIsSuccess] = useState({});
  const [cargoOpenPay, setCargoOpenPay] = useState(null);
  const [dataNavBar, setDataNavBar] = useState(null);
  const [loader, setLoader] = useState(true);
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const [origenId, setOrigenId] = useState(null);

  const data = [{
    id: 1
  }]
  
  async function responsiveSize(screens) {
    let screennow;
    {
      Object.entries(screens)
        .filter((screen) => !!screen[1])

        .map((screen) => (
          screennow = screen[0]
        ))
    }

    switch (screennow) {
      case "xxl":
        containerStyle.top = '2%';
        stylesNavBar.navBarHeigth = '65px';
        stylesNavBar.iconsNavbarWidth = '165px';
        stylesNavBar.iconsNavbarHeigth = '200px';
        stylesNavBar.stepsSize = 'large';
        stylesNavBar.paddingImg = '0px';
        cardPrincipalStyle.width = '98%';

        divresponsive.minHeight = '360px';
        rowFooterStyle.marginTop = '0px';
        rowFooterStyle.bottom = '0px';

        break;
      case "xl":

        containerStyle.top = '2%';
        stylesNavBar.navBarHeigth = '65px';
        stylesNavBar.iconsNavbarWidth = '165px';
        stylesNavBar.iconsNavbarHeigth = '200px';
        stylesNavBar.stepsSize = 'large';
        stylesNavBar.paddingImg = '0px';

        cardPrincipalStyle.width = '98%';

        rowFooterStyle.marginTop = '0px';
        rowFooterStyle.bottom = '0vh';
        divresponsive.minHeight = '360px';

        break;
      case "lg":

        containerStyle.top = '2%';
        stylesNavBar.navBarHeigth = '65px';
        stylesNavBar.iconsNavbarWidth = '165px';
        stylesNavBar.iconsNavbarHeigth = '200px';
        stylesNavBar.stepsSize = 'large';
        stylesNavBar.paddingImg = '10px';

        cardPrincipalStyle.width = '100%';

        rowFooterStyle.marginTop = '0px';
        rowFooterStyle.bottom = '0px';
        divresponsive.minHeight = '360px';

        break;
      case "md":

        containerStyle.top = '2%';
        stylesNavBar.navBarHeigth = '100px';
        stylesNavBar.iconsNavbarWidth = '120px';
        stylesNavBar.iconsNavbarHeigth = '150px';
        stylesNavBar.stepsSize = 'small';
        stylesNavBar.paddingImg = '10px';
        cardPrincipalStyle.width = '100%';

        rowFooterStyle.marginTop = '0px';
        rowFooterStyle.bottom = '0px';
        divresponsive.minHeight = '860px';

        break;
      case "sm":

        containerStyle.top = '2%';
        stylesNavBar.navBarHeigth = '100px';
        stylesNavBar.iconsNavbarWidth = '120px';
        stylesNavBar.iconsNavbarHeigth = '150px';
        stylesNavBar.stepsSize = 'small';
        stylesNavBar.paddingImg = '10px';

        cardPrincipalStyle.width = '100%';

        rowFooterStyle.marginTop = '0px';

        rowFooterStyle.bottom = '0px';
        divresponsive.minHeight = '860px';

        break;
      case "xs":

        stylesNavBar.navBarHeigth = '100px';
        stylesNavBar.iconsNavbarWidth = '120px';
        stylesNavBar.iconsNavbarHeigth = '150px';
        stylesNavBar.stepsSize = 'small';
        stylesNavBar.paddingImg = '10px';
        cardPrincipalStyle.width = '100%';


        rowFooterStyle.marginTop = '0px';
        rowFooterStyle.bottom = '0px';

        divresponsive.minHeight = '860px';

        break;

      default:
        break;
    }
  }
  responsiveSize(screens)


  const CARD_BRAND_ID_MAP = {
  visa: 1,
  mastercard: 2,
  american_express: 3,
  amex: 3
};

  useEffect(() => {
    async function recuperarCargo() {
      try {
        if (idCargo.length < 25) {
          const idCargoOpenpay = idCargo.split('=');
          let response = await recuperarCargoOpenPay(idCargoOpenpay[1]);

          if (response.data.status == "completed") {
            let pedidoId = response.data.orderId.split("-")[1];
            //obtenemos el origenid de la respuesta de openpay
            let origenid = response.data.orderId.split("-")[ORIGEN_ID.APYMSA] ?? ORIGEN_ID.CRM;
            setOrigenId(Number(origenid));
            let pedidos = await getDataPedidoOrigen(pedidoId, origenid);
            let pedido = pedidos.data.data.at(-1);
            let dataLiga = await getDataLigasIdPedido(pedido.id);
            dataLiga.data.data[0].fechaHoraPago = Date.now();
            dataLiga.data.data[0].nombreTarjeta = response.data.card.holderName;
            dataLiga.data.data[0].pagoExternoId = response.data.id;
            //Campo a quitar Tarjeta
            dataLiga.data.data[0].tarjeta = response.data.card.cardNumber;
            const cardBrand = response.data.card.brand;
            const tipoTarjeta = CARD_BRAND_ID_MAP[response.data.card.brand] || null;
            let obj = {
                status: "completed",
                pedidoPasarelaId: dataLiga.data.data[0].pedidoPasarelaId
              }
            setIsSuccess(obj);
            setCargoOpenPay(dataLiga.data.data[0]);
            var date = new Date();
            var day = date.getDate();       // yields date
            var month = date.getMonth() + 1;    // yields month (add one as '.getMonth()' is zero indexed)
            var year = date.getFullYear();  // yields year
            var hour = String(date.getHours());     // yields hours 
            var minute = String(date.getMinutes()); // yields minutes
            var second = String(date.getSeconds()); // yields seconds
            var splithour = "";
            var splitminute = ""
            var splitsecond = ""
            if (hour.length < 2) {
              splithour = "0" + hour;
            } else {
              splithour = hour;
            }
            if (minute.length < 2) {
              splitminute = "0" + minute;
            }
            else {
              splitminute = minute;
            }
            if (second.length < 2) {
              splitsecond = "0" + second;
            } else {
              splitsecond = second;
            }

            // After this construct a string with the above results as below           
            var time = year + "-" + month + "-" + day + "T" + splithour + ':' + splitminute + ':' + splitsecond;
            var digitosTarjeta = response.data.card.cardNumber.substring(response.data.card.cardNumber.length - 4);
            var isDebit = true;

            if (response.data.card.type == "debit") {
              isDebit = true;
            } else {
              isDebit = false;
            }
            if (dataLiga.data.data[0].estatusId !== EstatusPagoEnum.Pagado)
            {
              const newState = await dataLiga.data.data.map(obj => {
              return {
                ...obj,
                fechaHoraPago: time,
                nombreTarjeta: response.data.card.holderName,
                pagoExternoId: response.data.id,
                //Campo a quitar Tajeta
                tarjeta: parseInt(digitosTarjeta),
                estatusId: EstatusPagoEnum.Pagado,
                esDebito: isDebit,
                autorizacion: response.data.authorization,
                codigoBanco: response.data.card.bankCode,
                nombreBanco: response.data.card.bankName,
                numeroTarjeta: response.data.card.cardNumber,
                tipoTarjeta: tipoTarjeta
              };
            });
              await updateDataLiga(newState[0]);
              if (origenId !== ORIGEN_ID.APYMSA){
                var responsecorreo = await enviarCorreoPago(response.data.card.holderName, response.data.orderId.split("-")[1], response.data.amount, dataLiga.data.data[0].correo,response.data.id, formatDate(response.data.creationDate));
              }
            }

            
            
    
          }
          setLoader(false);
        } else {
          let responseCrypt = await desencryptURL(idCargo);
          if (responseCrypt != false) {
            let responseDataLiga = await getDataLigas(responseCrypt);
            setCargoOpenPay(responseDataLiga.data.data);
            if (responseDataLiga.data.data.estatusId == EstatusPagoEnum.Pagado) {
              let obj = {
                status: "completed",
                pedidoPasarelaId: responseDataLiga.data.data.pedidoPasarelaId
              }
              setIsSuccess(obj);
              setLoader(false);
            }
          }
        }
      } catch (error) {
        setLoader(false);
      }
    }
    recuperarCargo();
  }, [idCargo]);

  
  useEffect(() => {
    if (isSuccess?.status === "completed" && origenId === ORIGEN_ID.APYMSA) {
      const timer = setTimeout(() => {
        window.location.href = ORIGEN_CONFIG[ORIGEN_ID.APYMSA].backUrl;
      }, 8000);

      return () => clearTimeout(timer);
    }
  }, [isSuccess, origenId]);


  return (

    <div className="Error">
      <NavBar stylesNavBar={stylesNavBar} sucursal={data}/>
      <div style={divStyle}></div>
      <div style={divresponsive}>
        <div className="container" style={containerStyle}>

          {loader ? (<Spin size="large" />) : (
            // <Content style={contentStyle}>
            <Card style={cardPrincipalStyle} bodyStyle={cardBodyStyle} >
              {isSuccess.status === "completed" ?
                (<div>
                  <ConfigProvider
                    theme={{
                      token: {
                        colorSuccess: '#53B927',
                        subtitleFontSize: 16
                      },
                      components: {
                        Result: {
                          extraMargin: '0px 0 0 0',
                          subtitleFontSize: 20,
                          colorTextHeading: '#53B927',
                          colorTextDescription: '#3D3D3D'
                        }
                      }
                    }}
                  >
                    <Result
                      status="success"
                      title="¡Pago realizado!"
                      subTitle="Tu pago ha sido realizado con éxito. Gracias por tu compra."

                    />
                    { isSuccess.status === "completed" ? <InformacionPagoCompletado
                      pedidoPasarelaId={isSuccess.pedidoPasarelaId}
                      cargoOpenPay={cargoOpenPay}
                    />: <Error />}
                  </ConfigProvider>
                </div>
                )
                :
                (
                  <div>
                    <ConfigProvider
                      theme={{
                        token: {
                          colorSuccess: '#ff4d4f',
                          subtitleFontSize: 16
                        },
                        components: {
                          Result: {
                            extraMargin: '0px 0 0 0',
                            subtitleFontSize: 20,
                            colorTextHeading: '#ff4d4f',
                            colorTextDescription: '#3D3D3D'
                          }
                        }
                      }}
                    >
                      <Result
                        status="error"
                        title="¡Pago rechazado!"
                      />
                      
                    </ConfigProvider>
                  </div>
                )
              }
              <Row>
                <Col style={{ textAlign: 'center' }} xs={{ span: 19, offset: 3 }} sm={{ span: 19, offset: 3 }} md={{ span: 19, offset: 3 }} lg={{ span: 19, offset: 3 }} className="gutter-row" >
                  <Title level={4} className="custom-title">Para cualquier duda o seguimiento, contacta a  un ejecutivo de nuestro centro de atención.</Title>
                </Col>
              </Row>
            <Row style={{ display: 'flex', justifyContent: 'center', gap: '40px', marginTop: '20px' }}>
              {/* Teléfono */}
              <Col>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <img className='custom-WhatsApp-width' style={{ marginRight: 8 }} src={llamadaico} width={32} height={32} alt="Llamada" />
                  <p style={{ margin: 0, color: 'black' }} className="custom-WhatsApp">TELEFONO: 3332084420</p>
                </div>
              </Col>

              {/* WhatsApp 1 */}
              <Col>
                <a href="https://wa.me/523316026164?text=¡Necesito ayuda con mi pago!" style={{ textDecoration: 'none' }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img className='custom-WhatsApp-width' src={whatsappico} width={30} height={30} alt="WhatsApp" />
                    <p style={{ margin: 0, marginRight: 8, color: 'black' }} className="custom-WhatsApp">APYMSA: 3316026164</p>
                  </div>
                </a>
              </Col>
              {/* WhatsApp 2 */}
              <Col>
                <a href="https://wa.me/3316025603?text=¡Necesito ayuda con mi pago!" style={{ textDecoration: 'none' }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <img className='custom-WhatsApp-width' src={whatsappico} width={30} height={30} alt="WhatsApp" />
                    <p style={{ margin: 0, marginRight: 8, color: 'black' }} className="custom-WhatsApp">AUTEX: 3316025603</p>
                  </div>
                </a>
              </Col>
            </Row>
            </Card>
          )}
        </div>
        <div style={rowFooterStyle}>
          <Row >
            <Col xs={{ span: 24, order: 5 }} sm={{ span: 24, order: 5 }} md={{ span: 24, order: 5 }} lg={{ span: 24, order: 5 }} xl={{ span: 24, order: 5 }} xxl={{ span: 24, order: 5 }}>
              <Footer footerStyle={footerStyle}></Footer>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
}

export default Pagado;